export const tnp=[
  {
    "displayText": "TRAINING & PLACEMENT DETAILS",
    "filename": "./assets/documentation/tnp/TRAINING & PLACEMENT DETAILS.pdf",
    "link": ""
  }
]